import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';
import { getEnvVariable } from '../utils/getEnvVariable';

const FALLBACK_DSN =
  'https://af37e4d090b66888394453ea319f8564@o4509955954311168.ingest.us.sentry.io/4509956048355328';

export const useSentry = () => {
  const dsn = getEnvVariable('REACT_APP_SENTRY_DSN', FALLBACK_DSN);

  useEffect(() => {
    if (!dsn) return;
    Sentry.init({
      dsn,
      release: getEnvVariable('REACT_APP_HEROKU_RELEASE_VERSION', 'unknown'),
      ignoreErrors: [/network error/i, /Failed to fetch/i]
    });
  }, [dsn]);
};
